<c-form-field [control]="control">
  @if (label) {
    <ion-label class="phone__label">{{ label }}</ion-label>
  }

  <div class="phone__box" cFieldBox (focusout)="onTouched()">
    <ngx-intl-tel-input
      class="phone__field"
      [preferredCountries]="preferredCountries ?? []"
      [selectedCountryISO]="selectedCountry"
      [enableAutoCountrySelect]="true"
      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
      [enablePlaceholder]="false"
      [selectFirstCountry]="false"
      [maxLength]="15"
      [phoneValidation]="true"
      [separateDialCode]="false"
      [numberFormat]="PhoneNumberFormat.National"
      (keyup.enter)="keyenter.emit()"
      [formControl]="phoneControl"
      (keyup)="keyenter.emit()"
    ></ngx-intl-tel-input>
  </div>

  <c-field-message [helpText]="helpText" />
</c-form-field>
